// Per-company service switches, from GET /user-management/my-information. The API refuses a switched-off
// service with 403 (see the API's api/auth/service_guard.py); these hide its menus, dashboard blocks and pages.
// services is null until the user info has loaded, and then nothing is hidden.

// route prefix -> service key ('active': the company only has to be active)
const ROUTE_SERVICES = [
  ['/callInquiries', 'call'],
  ['/actionItemList', 'call'],
  ['/reviewManagement', 'promoter'],
  ['/businessPromoter', 'promoter'],
  ['/aiBusinessPromoter', 'promoter'],
  ['/staffsList', 'promoter'],
  ['/mapScan', 'mapScan'],
  ['/socialMedia', 'social'],
  ['/seo', 'seo'],
  ['/webInquiries', 'active'],
  ['/monthlyAnalytics', 'active'],
  ['/autopay', 'autopay'],
]

// an API without a field (older than the switches) counts as on
const flag = (value) => value === undefined ? true : !!value

export function servicesFromUserInfo(data) {
  return {
    active: data.service_active !== false,
    call: flag(data.call_services),
    seo: flag(data.seo_services),
    social: flag(data.social_media_services),
    promoter: flag(data.business_promoter_services),
    mapScan: flag(data.map_grid_services),
    deepScan: flag(data.map_grid_deep_search_services),
    // off unless the API says so: the server switch and the admin's per-company "allowed" (Card & Autopay)
    autopay: data.autopay_available === true,
  }
}

export function serviceOn(services, key) {
  if (!services) return key !== 'autopay'
  if (!services.active) return false
  return key === 'active' || !!services[key]
}

export function routeAllowed(services, path) {
  const rule = ROUTE_SERVICES.find(([prefix]) => path.startsWith(prefix))
  return !rule || serviceOn(services, rule[1])
}
